export default "__VITE_ASSET__c8d7575f__"